import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import OfferingActions from "../../../../reducers/modules/purchasing/offering/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "purchasing/offering";

export default class OfferingMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(OfferingActions.create());
    };
  }

  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(OfferingActions.approve());
      OfferingMiddleware.saveApprove(dispatch, post, search);
    };
  }

  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(OfferingActions.reject());
      OfferingMiddleware.saveReject(dispatch, post, search);
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(OfferingActions.update());
      OfferingMiddleware.showOne(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(OfferingActions.resetList());
    };
  }
  static list(params) {
    return (dispatch) => {
      dispatch(OfferingActions.process());
      OfferingMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(OfferingActions.reset());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(OfferingActions.view());
      OfferingMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(OfferingActions.submit());
      OfferingMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(OfferingActions.submit());
      OfferingMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(OfferingActions.delete());
      OfferingMiddleware.delete(dispatch, params, id);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static getHelper(params = null) {
    return (dispatch) => {
      OfferingMiddleware.showHelper(dispatch, params);
    };
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      OfferingMiddleware.showHelperFull(dispatch, params);
    };
  }

  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            OfferingActions.process(),
            OfferingMiddleware.showlist(dispatch, search)
          );
          dispatch(OfferingActions.success());
          OfferingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            OfferingActions.process(),
            OfferingMiddleware.showlist(dispatch, search)
          );
          dispatch(OfferingActions.success());
          OfferingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-offering-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(OfferingActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-offering-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(OfferingActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(OfferingActions.list(response.data.result));
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(OfferingActions.view(response.data.result));
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            OfferingActions.process(),
            OfferingMiddleware.showlist(dispatch, params)
          );
          OfferingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            OfferingActions.process(),
            OfferingMiddleware.showlist(dispatch, search)
          );
          dispatch(OfferingActions.success());
          OfferingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${OfferingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            OfferingActions.process(),
            OfferingMiddleware.showlist(dispatch, search)
          );
          dispatch(OfferingActions.success());
          OfferingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        OfferingMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(OfferingActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(OfferingActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
